﻿import { Accordion, AccordionHeader, AccordionItem, AccordionPanel } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { AwardGroupRef, Country } from '../../../models';
import { FlexBox } from '../../shared-components/flex-box';
import './AwardGroupList.scss';

interface AwardGroupListProps {
  onAwardSelected(award: AwardGroupRef): void;
  onCountrySelected(country: Country): void;
}

const AwardGroupListImpl: React.FC<AwardGroupListProps> = (props) => {
  const {
    onAwardSelected,
    onCountrySelected,
  } = props;

  const {
    winnersAndFinalistsPageUiStore
  } = useStores();

  const renderAwards = (awards: AwardGroupRef[]) => (
    <>
      {
        awards.map(award => (
          <FlexBox
            key={award.awardId}
            className='list-wrapper'
            aligns='center'
          >
            <button
              onClick={() => onAwardSelected(award)}
              key={award.awardId.toString()}
              className='panel__item'
            >
              {award.title}
            </button>
          </FlexBox>
        ))
      }
    </>
  );

  const renderCountries = () => (
    <>
      {
        winnersAndFinalistsPageUiStore.winnerCountries.map(country => (
          <button
            onClick={() => onCountrySelected(country)}
            key={country.countryId.toString()}
            className='panel__item'
          >
            {country.displayName}
          </button>
        ))
      }
    </>
  );

  return (
    <FlexBox
      direction='column'
      className='award-group-list'
    >
      <Accordion
        collapsible
        defaultOpenItems={1}
        className='award-group-list__accordion'
      >
        {
          winnersAndFinalistsPageUiStore.awardGroups.map((awardGroup, index) => {
            const key = awardGroup.awardGroupId.toString();
            return (
              <AccordionItem
                key={`award-group-${key}`}
                value={index + 1}
              >
                <AccordionHeader>{awardGroup.title}</AccordionHeader>
                <AccordionPanel>
                  {renderAwards(awardGroup.awards)}
                </AccordionPanel>
              </AccordionItem>
            );
          })
        }
        <AccordionItem
          value='country-awards'
        >
          <FlexBox
            className='list-wrapper'
            aligns='center'
          >
            <AccordionHeader>Country/Region</AccordionHeader>
          </FlexBox>
          <AccordionPanel>
            {renderCountries()}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </FlexBox>
  );
}

export const AwardGroupList = observer(AwardGroupListImpl);
